import { React, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Oracion from "./Oracion";
import imgRosario from "../assets/img/rosario.jpg";

export default function Misterio({ misterio }) {
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [oracionElegida, setOracionElegida] = useState("");
  const [fontSizes, setFontSizes] = useState(16);

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  return (
    <>
      <div className="container misterios">
        <div className={"font-" + fontSizes}>
          {misterio === "gozoso" && (
            <h6>
              Misterios <span>Gozosos</span>
            </h6>
          )}
          {misterio === "doloroso" && (
            <h6>
              Misterios <span>Dolorosos</span>
            </h6>
          )}
          {misterio === "glorioso" && (
            <h6>
              Misterios <span>Gloriosos</span>
            </h6>
          )}
          {misterio === "luminoso" && (
            <h6>
              Misterios <span>Luminosos</span>
            </h6>
          )}
          <p>
            <strong>1 -</strong> Señal de la Cruz.
          </p>
          <p>
            <strong>2 -</strong> Rezar el{" "}
            <b
              className="text-decoration-underline"
              // onclick="oracion('pesame')"
              onClick={() => {
                handleShow();
                setOracionElegida("pesame");
              }}
            >
              Pésame
            </b>
            .
          </p>
          <p>
            <strong>3 -</strong> Rezar la{" "}
            <b
              className="text-decoration-underline"
              // onclick="oracion('consagracionJesus')"s
              onClick={() => {
                handleShow();
                setOracionElegida("consagracionJesus");
              }}
            >
              Consagración al sacratísimo Corazón Eucarístico de Jesús
            </b>
            .
          </p>
          <p>
            <strong>4 -</strong> Leer el{" "}
            <strong>
              <a
                className="text-dark"
                href="https://evangeliodeldia.org/SP/gospel"
                rel="noreferrer"
                target="_BLANK"
              >
                Evangelio del día
              </a>
            </strong>
            .
          </p>
          <p>
            <strong>5 -</strong> Rezo{" "}
            <b
              className="text-decoration-underline"
              // onclick="oracion('bajoTuAmparo')"
              onClick={() => {
                handleShow();
                setOracionElegida("bajoTuAmparo");
              }}
            >
              Bajo Tu Ampáro
            </b>{" "}
            para el 1er Misterio y <b>Canto Ave María de Fatima</b> para el
            resto de los Misterios.
          </p>
          <p>
            <strong>6 -</strong> Leer un Mensaje de La Virgen y anunciar el
            Misterio correspondiente:
          </p>
          <div className="mt-3 mb-4 px-2">
            {misterio === "gozoso" && (
              <>
                <p>
                  <b>1er Misterio:</b> "La Anunciación del Angel a la Virgen
                  María y la Encarnación del Hijo de Dios".
                </p>
                <p>
                  <b>2do Misterio:</b> "La visita de María Santísima a su prima
                  Santa Isabel".
                </p>
                <p>
                  <b>3ro Misterio:</b> "El Nacimiento de Nuestro Señor
                  Jesucristo en el portal de Belén".
                </p>
                <p>
                  <b>4to Misterio:</b> "La presentación del Niño Jesús en el
                  Templo".
                </p>
                <p>
                  <b>5to Misterio:</b> "El Niño Jesús perdido y hallado en el
                  Templo".
                </p>
              </>
            )}
            {misterio === "doloroso" && (
              <>
                <p>
                  <b>1er Misterio:</b> "La oración de Jesús en el Huerto de los
                  olivos".
                </p>
                <p>
                  <b>2do Misterio:</b> "La Flagelación de Nuestro Señor".
                </p>
                <p>
                  <b>3ro Misterio:</b> "La Coronación de Espinas".
                </p>
                <p>
                  <b>4to Misterio:</b> "Jesús con la cruz a cuestas camino al
                  Calvario".
                </p>
                <p>
                  <b>5to Misterio:</b> "La Crucifixión y Muerte de Nuestro Señor
                  Jesucristo".
                </p>
              </>
            )}
            {misterio === "glorioso" && (
              <>
                <p>
                  <b>1er Misterio:</b> "La Resurreción de Nuestro Señor
                  Jesucristo".
                </p>
                <p>
                  <b>2do Misterio:</b> "La Ascensión de Nuestro Señor a los
                  cielos".
                </p>
                <p>
                  <b>3ro Misterio:</b> "La venida del Espíritu Santo sobre María
                  y sobre los Apóstoles".
                </p>
                <p>
                  <b>4to Misterio:</b> "La Asunción de María Santísima a los
                  cielos".
                </p>
                <p>
                  <b>5to Misterio:</b> "La Coronación de María Santísima como
                  Reina y Señora de todo lo creado".
                </p>
              </>
            )}
            {misterio === "luminoso" && (
              <>
                <p>
                  <b>1er Misterio:</b> "El Bautismo de Jesús en el Río Jordán".
                </p>
                <p>
                  <b>2do Misterio:</b> "La autorrevelación de Jesús en las Bodas
                  de Caná".
                </p>
                <p>
                  <b>3ro Misterio:</b> "El Anuncio de Jesús sobre el Reino de
                  Dios y su invitación a la conversión".
                </p>
                <p>
                  <b>4to Misterio:</b> "La Transfiguración de Jesús en el Monte
                  Tabor".
                </p>
                <p>
                  <b>5to Misterio:</b> "Jesús instituye la Eucaristía, expresión
                  sacramental del misterio pascual".
                </p>
              </>
            )}
          </div>
          <p>
            <strong>7 -</strong> Rezar un{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("padreNuestro");
              }}
            >
              Padre Nuestro
            </b>{" "}
            y 10{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("aveMaria");
              }}
            >
              Ave María
            </b>
            .
          </p>
          <p>
            <strong>8 -</strong> Rezar{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("gloria");
              }}
            >
              El Gloria
            </b>{" "}
            y las <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("jaculatorias");
              }}>Jaculatorias</b>.
          </p>
          <p>
            <strong>9 -</strong> Rezar{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("salve");
              }}
            >
              El Salve
            </b>{" "}
            y el{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("angelus");
              }}
            >
              Rezo del Angelus
            </b>
            .
          </p>
          <p>
            <strong>10 -</strong> Rezar un{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("padreNuestro");
              }}
            >
              Padre Nuestro
            </b>{" "}
            y la{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("sanMiguel");
              }}
            >
              Oración a San Miguel Arcángel
            </b>
            .
          </p>
          <p>
            <strong>11 -</strong> Rezar Las <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("jaculatoriasSanJose");
              }}>Jaculatorias a San José</b> y la{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("porLaPatria");
              }}
            >
              Oración por la Patria
            </b>
            .
          </p>
          <p>
            <strong>12 -</strong> Rezar La{" "}
            <b
              className="text-decoration-underline"
              onClick={() => {
                handleShow();
                setOracionElegida("consagracionVirgen");
              }}
            >
              Consagración al Corazón Inmaculado de María
            </b>
            .
          </p>
          <p>
            <strong>13 -</strong> Señal de la Cruz.
          </p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Oracion oracionElegida={oracionElegida} />
        <Modal.Footer>
          <Button className="btn-fundacion" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show1} onHide={handleClose1}>
        <Modal.Body>
          <div className="rosario-modal">
            <img src={imgRosario} alt="" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-fundacion" onClick={handleClose1}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="buttom-rosario d-flex">
        <button type="button" className="btn" onClick={handleShow1}>
          Guía
        </button>
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
